import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

export interface DrinkPricingTier {
  priceTrial?: number;
  priceWeekly?: number;
  priceMonthly?: number;
  priceNonOffer?: number;
}

export interface PlanAddon {
  _id?: string;
  name: string;
  description?: string;
  price: number;
  quantity?: string;
  isActive: boolean;
  image?: string;
}

export interface Plan {
  _id: string;
  title: string;
  description: string;
  price: number;
  priceWeekly: number;
  priceMonthly: number;
  priceNonOffer: number;
  priceLight?: number;
  priceWeeklyLight?: number;
  priceMonthlyLight?: number;
  priceNonOfferLight?: number;
  image?: string;
  duration: number;
  features: string[];
  isActive: boolean;
  isEnabled: boolean;
  ifPortionsAvailable?: boolean;
  planType: "meal" | "drink" | "meal_and_drink";
  drinkPricing?: {
    coffee?: DrinkPricingTier;
    blend?: DrinkPricingTier;
  };
  calorieRangeLight?: string;
  calorieRangeClassic?: string;
  isBestseller?: boolean;
  sortOrder?: number;
  badgeText?: string;
  addOns?: PlanAddon[];
  createdAt?: string;
  updatedAt?: string;
}

const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
  },
});

const plansApi = {
  getPlans: async (params?: { includeInactive?: boolean; all?: boolean }): Promise<Plan[]> => {
    const response = await axios.get(`${API_URL}/api/admin/plans`, {
      params: { includeInactive: true, ...params },
      ...getAuthHeaders(),
    });
    return response.data;
  },

  createPlan: async (data: Partial<Plan>): Promise<Plan> => {
    const response = await axios.post(`${API_URL}/api/admin/plans`, data, getAuthHeaders());
    return response.data;
  },

  updatePlan: async (id: string, data: Partial<Plan>): Promise<Plan> => {
    const response = await axios.put(`${API_URL}/api/admin/plans/${id}`, data, getAuthHeaders());
    return response.data;
  },

  patchPlan: async (id: string, data: Partial<Plan>): Promise<Plan> => {
    const response = await axios.patch(`${API_URL}/api/admin/plans/${id}`, data, getAuthHeaders());
    return response.data;
  },

  togglePlanActive: async (id: string, currentStatus: boolean): Promise<Plan> => {
    const response = await axios.patch(
      `${API_URL}/api/admin/plans/${id}`,
      { isActive: !currentStatus },
      getAuthHeaders()
    );
    return response.data;
  },

  togglePlanEnabled: async (id: string, currentStatus: boolean): Promise<Plan> => {
    const response = await axios.patch(
      `${API_URL}/api/admin/plans/${id}`,
      { isEnabled: !currentStatus },
      getAuthHeaders()
    );
    return response.data;
  },

  deletePlan: async (id: string): Promise<void> => {
    await axios.delete(`${API_URL}/api/admin/plans/${id}`, getAuthHeaders());
  },
};

export default plansApi;
